import React, { useEffect, useState } from 'react'

import { WorkflowLeaderboard } from '@src/pages/workflow/settings/challenge-items/workflow-leaderboard.component'
import { getChallengeResponsesForChallenge } from '@src/pages/workflow/settings/analytics.resource'
import { toastService } from '@utils/toast.service'

type WorkflowLeaderboardItemGenericProps = {
  workflowChallenge: WorkflowChallenge
  isAdmin: boolean
  onEdit: (challenge: WorkflowChallenge) => void
  onDelete: (id: string) => void
  participantsCount: number
}

export function WorkflowLeaderboardItemGeneric({
  workflowChallenge,
  isAdmin,
  onEdit,
  onDelete,
  participantsCount,
}: WorkflowLeaderboardItemGenericProps) {
  const [responses, setResponses] = useState<any[]>([])

  useEffect(() => {
    getChallengeResponsesForChallenge(workflowChallenge as any)
      .then(setResponses)
      .catch(err => {
        console.log(err)
        toastService.error(
          'There was an error retrieving challenge data. Please try again later.',
        )
      })
  }, [])

  return (
    <WorkflowLeaderboard
      workflowChallenge={workflowChallenge}
      responses={responses}
      displayGoal={(goal: string) =>
        `${goal} ${workflowChallenge.field!.dataLabel.toLowerCase()}`
      }
    >
      <WorkflowLeaderboard.Header
        canEdit={isAdmin}
        onEdit={onEdit}
        onDelete={onDelete}
        participantsCount={participantsCount}
      />
      <WorkflowLeaderboard.Body />
    </WorkflowLeaderboard>
  )
}
